import { useState } from 'react';
import { ExternalLink, FileDown, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { getApiErrorMessage } from '@/lib/apiError';
import { downloadFile, openFile } from '@/lib/downloadFile';

type PdfAction = 'open' | 'download';

/**
 * PDF d'une feuille soumise (GET /time_sheets/{id}/pdf, généré à la volée par l'API : la trame avec les lignes et les
 * signatures du moment) : l'ouvrir dans un nouvel onglet, ou le télécharger sous le nom donné par l'API
 * (« NOM Prénom - Heures supplémentaires … »).
 */
export function TimeSheetPdfButtons({ sheetId }: { sheetId: string | number }) {
  const [loading, setLoading] = useState<PdfAction | null>(null);
  const path = `/time_sheets/${sheetId}/pdf`;

  const run = async (action: PdfAction) => {
    setLoading(action);
    try {
      await (action === 'open' ? openFile(path) : downloadFile(path, 'feuille-d-heures.pdf'));
    } catch (error) {
      toast.error(getApiErrorMessage(error, "Le PDF n'a pas pu être généré, veuillez réessayer."));
    } finally {
      setLoading(null);
    }
  };

  return (
    <>
      <Button variant="outline" onClick={() => run('open')} disabled={loading !== null}>
        {loading === 'open' ? <Loader2 className="animate-spin" /> : <ExternalLink />}
        Ouvrir le PDF
      </Button>
      <Button variant="outline" onClick={() => run('download')} disabled={loading !== null}>
        {loading === 'download' ? <Loader2 className="animate-spin" /> : <FileDown />}
        Télécharger le PDF
      </Button>
    </>
  );
}
